/**
 * Accessible on/off switch built on a native checkbox (styled in index.css).
 *
 * @param {boolean} checked
 * @param {(next: boolean) => void} onChange
 * @param {boolean} [disabled]
 * @param {string} [id]
 * @param {string} [ariaLabel]
 */
function ToggleSwitch({ checked, onChange, disabled = false, id, ariaLabel }) {
  return (
    <label className={`toggle-switch ${disabled ? "is-disabled" : ""}`}>
      <input
        id={id}
        type="checkbox"
        role="switch"
        aria-label={ariaLabel}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="toggle-track" aria-hidden="true">
        <span className="toggle-thumb" />
      </span>
    </label>
  );
}

export default ToggleSwitch;
